import React, {useState} from "react";

function BulkLocationEditorTemporarilyClosed ({locationPatchTemporarilyClosed, updateLocationPatchSection}) {

  const _isTemporarilyClosedState = locationPatchTemporarilyClosed !== undefined && locationPatchTemporarilyClosed !== null;
  const _reOpenLocationState = locationPatchTemporarilyClosed === null; // If we want to remove temporarily closed until date
  const _reOpeningDateState = _isTemporarilyClosedState && !_reOpenLocationState ? locationPatchTemporarilyClosed : "";

  const [isTemporarilyClosed, setIsTemporarilyClosed] = useState(_isTemporarilyClosedState);
  const [reOpenLocations, setReOpenLocations] = useState(_reOpenLocationState);
  const [reOpeningDate, setReOpeningDate] = useState(_reOpeningDateState); // Example: 2020-05-01

  const toggleIsTemporarilyClosed = (event) => {
    const selected = event.target.checked;

    if (selected === false) {
      setReOpenLocations(false);
      setReOpeningDate("");

      updateLocationPatchSection(undefined);
    }

    setIsTemporarilyClosed(selected);
  };

  const toggleReOpenLocations = (event) => {
    const selected = event.target.checked;

    setIsTemporarilyClosed(false);
    if (selected === true) {
      setIsTemporarilyClosed(false);
      setReOpeningDate("");

      updateLocationPatchSection(null); // Null will delete the temporarily closed until date
    } else {
      updateLocationPatchSection(undefined);
    }

    setReOpenLocations(selected);
  };

  const setReopeningDateFromInput = (event) => {
    const reOpeningDate = event.target.value;
    setReOpeningDate(reOpeningDate);

    updateLocationPatchSection(reOpeningDate);
  };

  return <div className="card-spacer-top card-spacer-bottom">
    <h5 className="card-spacer-top card-spacer-bottom">Temporarily Closed</h5>
    <form className="form-inline card-spacer-bottom">
      <div className="custom-control custom-checkbox">
        <input type="checkbox" id="temporarilyclosedcheckbox" className="custom-control-input" disabled={reOpenLocations} defaultChecked={isTemporarilyClosed} onClick={toggleIsTemporarilyClosed}/>
        <label className="custom-control-label" htmlFor="temporarilyclosedcheckbox">Temporarily Closed</label>
      </div>
    </form>
    {isTemporarilyClosed && <div>Estimated Re-Opening Date <input className="form-control" type="date"  style={{width: "166px"}} value={reOpeningDate} onChange={setReopeningDateFromInput}/></div>}
    <div className="custom-control custom-checkbox content-spacer-top">
      <input type="checkbox" id="reopencheckbox" className="custom-control-input" disabled={isTemporarilyClosed} defaultChecked={reOpenLocations} onClick={toggleReOpenLocations}/>
      <label className="custom-control-label" htmlFor="reopencheckbox">Reopen temporarily closed locations</label>
    </div>
  </div>
}

export default BulkLocationEditorTemporarilyClosed;